import { render, staticRenderFns } from "./CallsView.vue?vue&type=template&id=7555fba6&scoped=true"
import script from "./CallsView.vue?vue&type=script&lang=js"
export * from "./CallsView.vue?vue&type=script&lang=js"
import style0 from "./CallsView.vue?vue&type=style&index=0&id=7555fba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555fba6",
  null
  
)

export default component.exports